export default __webpack_public_path__ + "static/media/290.54c73595.jpg";